import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { PPAuthService } from '../../../core/services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-email-register-form',
  templateUrl: './email-register-form.component.html',
  styleUrls: ['./email-register-form.component.scss'],
})
export class EmailRegisterFormComponent implements OnInit {

  form: FormGroup;
  firstName: FormControl;
  lastName: FormControl;
  email: FormControl;
  matchingPasswords: FormGroup;
  password: FormControl;
  confirmPassword: FormControl;


  firstNameFirstBlur = false;
  firstNameFocus = false;
  lastNameFirstBlur = false;
  lastNameFocus = false;
  emailFirstBlur = false;
  emailFocus = false;
  passwordFirstBlur = false;
  passwordFocus = false;
  confirmPasswordFirstBlur = false;
  confirmPasswordFocus = false;
  tryToSubmit = false;

  returnUrl: string;

  loading$: Observable<boolean>;

  @Output() onSubmit = new EventEmitter<object>();

  constructor( private authService: PPAuthService,  private route: ActivatedRoute  ) { 

    this.loading$ = authService.registerByEmailLoading$; 

  }

  onFormSubmit() {

    this.tryToSubmit = true;

    if ( !this.form.valid ) {
      return false;
    }

    this.onSubmit.emit( {
      'firstName': this.firstName.value, 
      'lastName': this.lastName.value, 
      'email': this.email.value,
      'password': this.matchingPasswords.controls['password'].value 
    });

    this.authService.registerByEmail( 
      this.firstName.value,
      this.lastName.value,
      this.email.value,
      this.matchingPasswords.controls['password'].value,
      this.returnUrl
    );

  }

  matchValidator(group: FormGroup) {

    if ( group.controls['password'].value == group.controls['confirmPassword'].value ) {
      return null;
    }

    return {
      mismatch: true
    };

  }

  ngOnInit() {

    this.route.queryParams
      .subscribe(params => this.returnUrl = params['return']);

    this.firstName = new FormControl('', [ 
      Validators.required
    ]);

    this.lastName = new FormControl('', [ 
      Validators.required
    ]);

    this.email = new FormControl('', [ 
      Validators.required, 
      Validators.pattern( '[a-zA-Z0-9.-_]{1,}@[0-9a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}' )
    ]);

    this.password = new FormControl( '', [
      Validators.required,
      Validators.minLength(6)
    ]);

    this.confirmPassword = new FormControl( '', [
      Validators.required
    ]);

    this.matchingPasswords = new FormGroup({
      'password': this.password,
      'confirmPassword': this.confirmPassword
    }, [ this.matchValidator ] )

    this.form = new FormGroup({
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      matchingPasswords: this.matchingPasswords
    });

  }

}
